import React from "react";
import { classNames } from "src/helpers/classNames";
import PreloaderIcon from "src/components/Shared/LoadingAnimations/PreloaderIcon";

const Preloader = ({ text = "Loading...", className = "", size = "lg", circleDimension = "14" }) => {
  return (
    <div className={classNames("flex justify-center items-center gap-x-4 rounded py-5 px-8", className)}>
      <PreloaderIcon
        height={`h-${circleDimension}`}
        width={`w-${circleDimension}`}
      />
      <p className={`m-0 text-${size} text-gray-400`}>{text}</p>
    </div>
  );
};

export default Preloader;
